<template>
<div>
  <a-tabs
    tabPosition="left"
    @tabClick="handleTabClick"
    :defaultActiveKey="`${this.allMembersListReversed[0].id}`"
  >
    <a-tab-pane
      v-for="o in allMembersListReversed"
      :key="`${o.id}`"
      :tab="`№${o.id}`"
    >
      <ResultsContainer />
    </a-tab-pane>
  </a-tabs>
</div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import ResultsContainer from '../ResultsContainer';

export default {
  name: 'UsersList',
  components: {
    ResultsContainer,
    mapState
  },
  data () {
    return {
      activeKey:  ''
    }
  },
  mounted() {
    this.activeKey = this.allMembersListReversed[0].id
    this.$store.dispatch('getMemberQuizzesResult', this.activeKey )
    this.$store.commit('setCurrentMember', this.getInArray(this.allMembersListReversed, 'id', this.activeKey));
  },
  methods: {
    handleTabClick (key) {
      console.log('key',key)
      this.activeKey = key
      this.$store.commit('setCurrentMember', this.getInArray(this.allMembersListReversed, 'id', key));
      this.$store.dispatch('getMemberQuizzesResult', this.activeKey )
    },
    createMember (amount) {
      this.$store.dispatch('createMember', {id: null, amount: amount})
    },
  },
  computed: {
    allMembersListReversed () {
      return this.allMembersList.reverse()
    },
    ...mapState([
      'currentGroup',
      'allMembersList',
      'setCurrentMember'
    ]),
    ...mapGetters([
      'getGroup',
      'getInArray'
    ])
  },
}
</script>
<style scoped lang="scss">

.create-link-btn {
  display: inline-block;
  margin-bottom: 20px;
}
</style>